import type { ProfileInfoConfig } from '../../profileInfo.types.ts';
import { ROUTES } from './routes/routes.ts';

const PROFILE_INFO: ProfileInfoConfig = {
  isShowDetailedNameChangeVerification: true,
  nameChangeKycVerificationMethods: [{ name: 'manual-upload' }],
  nameChangeKycDialogTitleKey: 'name_change.title',
  nameChangeSkipVerificationRedirectPath: ROUTES.MY_ACCOUNT.ROOT,
  isUseNameChangeManualUploadCopy: true,
};

export { PROFILE_INFO };
